import * as React from "react"

import { cn } from "@/lib/utils"

// REGARA override: `field-sizing-content` grows the box with its text — with no
// cap, pasting a long text stretched it (and the page) without limit until the
// user dragged the resize handle. `max-h-80 overflow-y-auto`: it grows to 20rem,
// then scrolls inside. A caller needing a taller box sets its own max-h.
function Textarea({ className, ...props }: React.ComponentProps<"textarea">) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        "flex field-sizing-content min-h-16 max-h-80 overflow-y-auto w-full rounded-md border border-input bg-transparent px-3 py-2 text-base shadow-xs transition-[color,box-shadow] outline-none placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-destructive/20 md:text-sm dark:bg-input/30 dark:aria-invalid:ring-destructive/40",
        className
      )}
      {...props}
    />
  )
}

export { Textarea }
